import { values } from 'ramda'

const PLACE_TYPES = {
  LOCATION: 'location',
  PERSON: 'person',
  FLEET: 'fleet'
}

export const placeTypesOptions = values(PLACE_TYPES).map(type => ({ label: type, value: type }))

export default PLACE_TYPES
